import { events, emitEvent } from '../utilities/custom-events';
import { get } from '../utilities/router';
import { scrollTop } from '../utilities/scroll';

const ANIMATION_DURATION = 500; // miliseconds

export default class {
    constructor({
        id,
        contentHandle,
        lockedClass,
        activeClass,
        unloadingClass,
    }) {
    // Elements and class variables
        const el = document.getElementById(id);
        const content = el.querySelector(contentHandle);
        const loader = document.querySelector('.loader .loading-animation');

        // Event handler functions
        function handleLockScroll() {
            document.body.classList.add(lockedClass);
        }
        function handleUnlockScroll() {
            document.body.classList.remove(lockedClass);
        }
        function handleUnloadRoute() {
            // Animate page unload and scroll to top
            document.body.classList.add(unloadingClass);
            setTimeout(() => { scrollTop(); }, ANIMATION_DURATION);
            setTimeout(() => {
                loader.classList.add('loading-animation--animated');
            }, 500);
            setTimeout(() => {
                loader.classList.remove('loading-animation--animated');
            }, 3000);
        }
        function handleShowOverlay() {
            // Allow children of content to specify their own z-index to overlay header/footer
            content.style.zIndex = 'initial';
        }
        function handleHideOverlay() {
            content.style.zIndex = '';
        }
        function handleFancyModal(url, query = {}, modalConfig = {}) {
            function cb(res) {
                const { markup } = JSON.parse(res);

                emitEvent(events.stopLoader);
                emitEvent(events.loadFancyModal, { markup, ...modalConfig });
            }

            emitEvent(events.startLoader);
            get({ url, query, cb });
        }

        // Add event listeners
        window.addEventListener(events.lockScroll, handleLockScroll);
        window.addEventListener(events.unlockScroll, handleUnlockScroll);
        window.addEventListener(events.unloadRoute, handleUnloadRoute);
        window.addEventListener(events.showOverlay, handleShowOverlay);
        window.addEventListener(events.hideOverlay, handleHideOverlay);

        // Set initial state
        if (window.history && window.history.replaceState) {
            const replaceState = {
                ...window.history.state,
                url: window.location.href,
            };

            window.history.replaceState(replaceState, null);
        }

        // Initialize
        el.classList.add(activeClass);

        // Set var for when user first visits the site, so we can
        // do things like only show the homepage hero animation once etc.
        const newSession = sessionStorage.getItem('newSession');
        sessionStorage.setItem('newSession', true);
        document.querySelector('body').classList.toggle('new-session', newSession === null);

        window.addEventListener('pageshow', event => {
            if (event.persisted) {
                // page was restored from the bfcache
                document.body.classList.remove(unloadingClass);
                emitEvent(events.stopLoader);
            }
        });
        document.body.addEventListener('click', e => {
            const link = e.target.closest('a[href]');

            if (link && link.getAttribute('data-video-id')) {
                e.preventDefault();

                const videoId = link.getAttribute('data-video-id');
                const player = link.getAttribute('data-player');
                const query = { videoId, fancyModal: true, player };
                const full = true;
                const kiosk = link.getAttribute('data-modal-kiosk');
                const position = link.getAttribute('data-modal-position');
                const size = link.getAttribute('data-modal-size');

                handleFancyModal('/shared/video', query, {
                    full,
                    kiosk,
                    position,
                    size,
                });
            }
        });
    }
}
